import { memo } from 'react';

import AppModal from '../../AppModal';

const ConfirmationModal = ({
  isOpen = false,
  title = '',
  description = '',
  onCancel,
  onSubmit,
  cancelText = 'Cancel',
  submitText = 'Delete',
  submitButtonType = 'danger'
}) => {
  return (
    <AppModal
      title={title}
      isOpen={isOpen}
      cancelButtonText={cancelText}
      confirmButtonText={submitText}
      confirmButtonColor={submitButtonType}
      handleCancel={onCancel}
      handleConfirm={onSubmit}>
      <div className="py-4">{description}</div>
    </AppModal>
  );
};

export default memo(ConfirmationModal);
